import { LayoutTranslation } from '@/assets/locales/layout/layout.translation.en.ts';
import { PolishPlurals } from '@/assets/locales/PolishPlurals.model.ts';

export const layoutTranslation: PolishPlurals<LayoutTranslation> = {
  appName: 'Ankieter',
  appTagline: 'Testy i ankiety',
  sideMenu: {
    collapse: 'Zwiń menu',
    expand: 'Rozwiń menu',
    navigationLabel: 'Nawigacja główna',
  },
  userMenu: {
    open: 'Otwórz menu użytkownika',
    signedInAs: 'Zalogowano jako',
    signOut: 'Wyloguj się',
    switchToDark: 'Włącz ciemny motyw',
    switchToLight: 'Włącz jasny motyw',
  },
};
